<report-filter 
  showCostCenters='true'
  showFacilities='true'
  showShiftBlocks='true'
  showPeriodEndDateSelection='true'
  reportType='ancillary'
  ancillaryType='acuity'
  [(defaultFilter)]="filters"
  (filterUpdated)="filterUpdated($event)">
</report-filter>

<smt-dailychurnratereport
  [filtersUpdated]='filterEventsSubject.asObservable()' 
  (dataUpdated)='dataUpdated($event)'
  [(reportFilters)]='filters'>
</smt-dailychurnratereport>

<table class='condensed' role='list'>
    <thead>
      <th><!-- empty row for the series names --></th>
      <th *ngFor='let item of data.xAxis'><div>{{item}}&nbsp;&nbsp;</div></th>
    </thead>
    <tr *ngFor='let dataSet of chartData'>
      <td>{{dataSet.name}}</td> 
      <td *ngFor='let item of dataSet.data'>{{formatValue(item)}}</td>
    </tr>
  </table>